interface PortalDataListProps {
  title: string;
  description?: string;
  loading?: boolean;
  emptyMessage?: string;
  items: Array<{ id: string | number; primary: string; secondary?: string; meta?: string }>;
}

export function PortalDataList({ title, description, loading, emptyMessage, items }: PortalDataListProps) {
  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">{title}</h1>
        {description && <p className="text-slate-500 dark:text-slate-400 mt-1">{description}</p>}
      </div>
      {items.length === 0 ? (
        <div className="card p-8 text-center text-slate-500 dark:text-slate-400">
          {emptyMessage ?? 'Nothing here yet.'}
        </div>
      ) : (
        <ul className="card divide-y divide-slate-100 dark:divide-slate-800">
          {items.map((item) => (
            <li key={item.id} className="px-4 py-3 flex items-center justify-between gap-4">
              <div className="min-w-0">
                <p className="font-medium text-slate-900 dark:text-slate-100 truncate">{item.primary}</p>
                {item.secondary && (
                  <p className="text-sm text-slate-500 dark:text-slate-400 truncate">{item.secondary}</p>
                )}
              </div>
              {item.meta && (
                <span className="text-xs font-medium px-2 py-1 rounded-full bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300 shrink-0">
                  {item.meta}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
